import { render } from "./App.vue?vue&type=template&id=8b6be1b8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8b6be1b8&lang=css"

import exportComponent from "/Users/jamest/local_sites/EliteInsights/wp.eliteinsights.com/html/wp-content/plugins/wp-opinion-custom-voting-page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__